
export default function Features() {
  const features = [
    {
      point: 'POINT 01',
      title: '業界最高水準！還元率50〜70％',
      description: '頑張った分だけしっかり稼げる完全歩合制。時給換算で4,000円〜5,000円以上も可能です。「最低時給保証」もあるので、閑散期や未経験の方でも安心してお仕事に集中できます。',
      icon: 'ri-money-cny-box-line'
    },
    {
      point: 'POINT 02',
      title: '全額日払い＆深夜送迎あり',
      description: 'お給料はその日のうちに全額日払いが可能。急な出費があっても安心です。また、ラストまで勤務して終電を逃しても、専属ドライバーが自宅まで安全にお送りします。',
      icon: 'ri-car-line'
    },
    {
      point: 'POINT 03',
      title: '完全自由シフトでプライベート充実',
      description: '週1日、1日4時間から勤務OK。「昼間の空き時間だけ」「週末だけ副業」「レギュラーでガッツリ」など、あなたのライフスタイルに合わせた働き方が可能です。',
      icon: 'ri-calendar-check-line'
    }
  ];

  return (
    <section id="features" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-pink-500 font-bold text-sm mb-3 tracking-wider">MERIT</span>
          <h2 className="text-2xl sm:text-4xl font-bold text-gray-800 mb-4">
            咲くら庵が選ばれる<span className="text-pink-500">3つの理由</span>
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            待遇の良さを具体的に伝えます
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white p-8 rounded-2xl shadow-lg border border-gray-100 hover:border-pink-200 hover:shadow-xl transition-all duration-300 relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 bg-pink-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg">
                {feature.point}
              </div>
              <div className="w-16 h-16 flex items-center justify-center bg-pink-100 rounded-full mb-6 group-hover:bg-pink-500 transition-colors">
                <i className={`${feature.icon} text-3xl text-pink-500 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4 min-h-[3.5rem] flex items-center">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed text-justify">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
